export const units = {
  volume: {
    sqmeter: 'м²',
    kg: 'кг',
    liter: 'литр',
    piece: 'шт',
  },
  currency: {
    rur: '₽',
    usd: '$',
  },
};

export const materialStatus = {
  new: 'Новая',
  progress: 'В работе',
  review: 'Проверка',
  rework: 'На доработку',
  coordination: 'Согласование',
  contract: 'Договор',
  measuring: 'Замер',
  production: 'В производстве',
  delivery: 'Доставка',
  assembly: 'Монтаж',
  closed: 'Завершена',
  paused: 'Пауза',
  stock: 'На складе',
};

export default { units, materialStatus };
